module.exports = __webpack_public_path__ + "img/alex-training-library.71788f97.png";